import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import Navbar from "../../../Components/Navbar/Navbar";
import { CSVLink } from "react-csv";
import DatePicker from "react-datepicker";
import { UseGetRequest } from "../../../Helpers/Hooks/GetApiRequests";
import { selectDropdownStyle } from "../../../Helpers/Utils/Common";
import Select from "react-select";
import { Divider } from "antd";
import Footer from "../../../Components/Footer/Footer";

function AuditTrails() {
  const [inactive, setInactive] = useState(true);
  const [report, setReport] = useState([]);
  const [filter, setFilter] = useState({
    date_from: new Date().toLocaleDateString("en-CA"),
    date_to: new Date().toLocaleDateString("en-CA"),
    branch_id: null,
  });
  const [branchOptions, setBranchOptions] = useState([]);

  const exportHeaders = [
    { label: "Col. Name", key: "col_name" },
    { label: "Doc. Name", key: "doc_name" },
    { label: "New Value", key: "new_value" },
    { label: "Old Value", key: "old_value" },
    { label: "Order No.", key: "order_no" },
  ];

  const handleFilter = (e) => {
    const { name, value } = e.target;
    var filtercopy = { ...filter };
    filtercopy[name] = value;
    setFilter(filtercopy);
  };

  /** EXPORT */
  function handleToCSV() {
    return (
      <CSVLink
        filename={"AuditTrails.csv"}
        data={report}
        headers={exportHeaders}
      >
        <button
          className="custom-primary-btn py-4"
          disabled={!filter.branch_id}
        >
          Export to CSV
        </button>
      </CSVLink>
    );
  }

  async function fetchReportData() {
    if (filter.branch_id) {
      const response = await UseGetRequest("reports/auditTrails", filter);
      if (response.data) {
        setReport(response.data);
      }
    }
  }

  useEffect(() => {
    fetchReportData();
  }, [filter]);

  useEffect(() => {
    async function fetchAllBranches() {
      setBranchOptions([]);
      const response = await UseGetRequest("branches/get_all_branch", {});
      if (response.data) {
        const temp = response.data.data.map((row) => {
          var info = {};
          info.label = row.name;
          info.value = row.id;
          return info;
        });
        setBranchOptions([{ label: "All", value: null }, ...temp]);
      }
    }

    fetchAllBranches();
  }, []);

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"REPORTS"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        
        <Row className="mb-4">
          <Col xs={12} lg={7}>
              <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> Audit Trails </h1>
          </Col>
        </Row>
        <hr />
        <div className="mb-3" />
        <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
            Filter By:
        </span>
        <Row className="PO-filters flex flex-row mx-2 my-1">
          <Col xs={6} lg={2}>
            <DatePicker
              autoComplete="off"
              name="date_from"
              placeholderText={"Select Date From"}
              onChange={handleFilter}
              value={filter.date_from}
              fixedHeight
              className="date-filter me-4 form-control py-3"
              showYearDropdown
              dateFormatCalendar="MMMM"
              yearDropdownItemNumber={20}
              scrollableYearDropdown
            />
          </Col>
          <Col xs={6} lg={2}>
            <DatePicker
              autoComplete="off"
              name="date_from"
              placeholderText={"Select Date To"}
              onChange={handleFilter}
              value={filter.date_to}
              fixedHeight
              className="date-filter me-4 form-control py-3"
              showYearDropdown
              dateFormatCalendar="MMMM"
              yearDropdownItemNumber={20}
              scrollableYearDropdown
            />
          </Col>
          <Col xs={12} lg={4} className="mt-2 mt-lg-0">
                  <Select
                     className="dropsearch-filter"
                     classNamePrefix="react-select"
                    placeholder={"All Branches"}
                    styles={selectDropdownStyle}
                    options={branchOptions}
                    onChange={(e) =>
                      setFilter((prev) => ({ ...prev, branch_id: e.value }))
                    }
                  />
          </Col>
        </Row>
        <div className="mb-2" />
        <div className="report-tab-content">
          <Divider/>
          <Row className="d-flex justify-content-center my-5">
            <Col xs={8} md={4} lg={3} className="">
              {handleToCSV()}
            </Col>
          </Row>
        </div>
      </div>
      <Footer/>
    </div>
  );
}

export default AuditTrails;
